import { useQuery } from '@tanstack/react-query';
import { getWholesaleManagerial } from '../services/wholesaleManagerialService';

export const useWholesaleManagerial = (month: string = '2025-04') => {
  return useQuery({
    queryKey: ['wholesale-managerial-dashboard', month],
    queryFn: () => getWholesaleManagerial(month),
    staleTime: 1000 * 60 * 5, 
  });
};
